import Vue from 'vue'
import VueLazyLoad from 'vue-lazyload'
import 'element-ui/lib/theme-chalk/index.css';

import { Carousel, CarouselItem } from 'element-ui'

Vue.config.productionTip = false

Vue.use(VueLazyLoad,{
  // error:require('../static/sy-logo.png'),
  // loading:require('../static/sy-logo.png')
})

Vue.use(Carousel)
Vue.use(CarouselItem)


// WEBPACK FOOTER //
// ./src/index.js